export const pricingCategories = [
  {
    category: 'Micro-Needling & BioRePeel',
    items: [
      { name: 'Gesichtsbehandlung - Microneedling Anti Aging', duration: '60 Min.', price: '110€' },
      { name: 'Microneedling mit Bio RePeel Cl3', duration: '75 Min.', price: '129€' },
      { name: 'Hyropeptide Behandlung mit Microneedling', duration: '75 Min.', price: '129€' },
      { name: 'Gesichtsbehandlung - Microneedling mit BioRePeel', duration: '75 Min.', price: '129€' }
    ]
  },
  {
    category: 'Dauerhafte Haarentfernung (Nur für Damen)',
    items: [
      { name: 'Intim', duration: '10 Min.', price: 'ab 40€' },
      { name: 'Bikini', duration: '10 Min.', price: 'ab 40€' },
      { name: 'Unterschenkel', duration: '20 Min.', price: 'ab 69€' },
      { name: 'Oberschenkel', duration: '20 Min.', price: 'ab 69€' },
      { name: 'Beine komplett', duration: '25 Min.', price: 'ab 90€' },
      { name: 'Unterarme', duration: '30 Min.', price: 'ab 45€' },
      { name: 'Oberarme', duration: '30 Min.', price: 'ab 45€' },
      { name: 'Arme komplett', duration: '25 Min.', price: 'ab 75€' },
      { name: 'Achseln', duration: '10 Min.', price: 'ab 49€' },
      { name: 'Schultern', duration: '20 Min.', price: 'ab 50€' },
      { name: 'Bauch', duration: '20 Min.', price: 'ab 60€' },
      { name: 'Brust', duration: '20 Min.', price: 'ab 55€' },
      { name: 'Ganzkörper', duration: '75 Min.', price: 'ab 200€' },
      { name: 'Gesicht', duration: '20 Min.', price: 'ab 75€' },
      { name: 'Oberlippe', duration: '10 Min.', price: 'ab 35€' },
      { name: 'Kinn', duration: '10 Min.', price: 'ab 35€' },
      { name: 'Achsel, Bikini, Intim', duration: '30 Min.', price: 'ab 119€' },
      { name: 'Oberlippe + Kinn', duration: '20 Min.', price: 'ab 59€' },
      { name: 'Beratung', duration: '15 Min.', price: '1€' },
      { name: 'Kotletten', duration: '10 Min.', price: 'ab 20€' },
      { name: 'Wangenknochen', duration: '15 Min.', price: 'ab 30€' },
      { name: 'Nacken', duration: '15 Min.', price: 'ab 30€' },
      { name: 'Achseln, Schultern und Nacken', duration: '45 Min.', price: 'ab 145€' },
      { name: 'Hals', duration: '15 Min.', price: 'ab 35€' },
      { name: 'Wangen und Hals', duration: '30 Min.', price: 'ab 50€' },
      { name: 'Füße', duration: '15 Min.', price: 'ab 25€' }
    ]
  },
  {
    category: 'Maniküre & Pediküre (Nur für Damen)',
    items: [
      { name: 'Kosmetische Pediküre', duration: '35-40 Min.', price: 'ab 35€' },
      { name: 'Fußnägel lackieren', duration: '15 Min.', price: '10€' },
      { name: 'Pediküre mit Fußbad und Peeling', duration: '40 Min.', price: '42€' },
      { name: 'Spa Pediküre', duration: '60 Min.', price: '69€' },
      { name: 'Fuß- & Unterbeinmassage', duration: '15 Min.', price: '25€' },
      { name: 'Fußmaske', duration: '10 Min.', price: '15€' },
      { name: 'Entfernung vom Fremdmaterial', duration: '10 Min.', price: '10€' }
    ]
  },
  {
    category: 'Wimpern & Augenbrauen (Nur für Damen)',
    items: [
      { name: 'Augenbrauen färben & zupfen, Wimpern färben', duration: '40 Min.', price: '30€' },
      { name: 'Augenbrauen & Wimpern färben', duration: '20 Min.', price: '20€' },
      { name: 'Augenbrauen färben & zupfen', duration: '20 Min.', price: '20€' },
      { name: 'Augenbrauen färben', duration: '10 Min.', price: '10€' },
      { name: 'Wimpern färben', duration: '10 Min.', price: '10€' },
      { name: 'Wimpernlifting', duration: '60 Min.', price: 'ab 55€' },
      { name: 'Browlifting', duration: '60 Min.', price: 'ab 50€' },
      { name: 'Augenbrauen zupfen', duration: '15 Min.', price: '10€' },
      { name: 'Haarentfernung mit Fadentechnik - Augenbrauen', duration: '15 Min.', price: '12€' },
      { name: 'Haarentfernung mit Wax - Augenbrauen', duration: '15 Min.', price: '12€' },
      { name: 'Haarentfernung mit Fadentechnik - Oberlippe', duration: '10 Min.', price: '12€' }
    ]
  },
  {
    category: 'Nägel',
    items: [
      { name: 'Kosmetische Pediküre', duration: '35-40 Min.', price: 'ab 35€' },
      { name: 'Fußnägel lackieren', duration: '15 Min.', price: '10€' },
      { name: 'Pediküre mit Fußbad und Peeling', duration: '40 Min.', price: '42€' },
      { name: 'Spa Pediküre', duration: '60 Min.', price: '69€' },
      { name: 'Fuß- & Unterbeinmassage', duration: '15 Min.', price: '25€' },
      { name: 'Fußmaske', duration: '10 Min.', price: '15€' },
      { name: 'Entfernung vom Fremdmaterial', duration: '10 Min.', price: '10€' }
    ]
  },
  {
    category: 'Waxing (Nur für Damen)',
    items: [
      { name: 'Unterschenkel', duration: '30 Min.', price: '40€' },
      { name: 'Beine komplett', duration: '60 Min.', price: '55€' },
      { name: 'Achseln', duration: '20 Min.', price: '25€' },
      { name: 'Oberarme', duration: '30 Min.', price: '35€' },
      { name: 'Unterarme', duration: '30 Min.', price: '35€' },
      { name: 'Arme komplett', duration: '45 Min.', price: '45€' },
      { name: 'Augenbrauen', duration: '10 Min.', price: '12€' },
      { name: 'Gesicht komplett', duration: '30 Min.', price: '25€' },
      { name: 'Oberlippe', duration: '10 Min.', price: '10€' },
      { name: 'Kinn', duration: '10 Min.', price: '8€' },
      { name: 'Oberlippe und Kinn', duration: '20 Min.', price: '15€' },
      { name: 'Haarentfernung mit Fadentechnik - Gesicht', duration: '20 Min.', price: '25€' }
    ]
  },
  {
    category: 'Aqua Facial',
    items: [
      { name: 'Gesichtsbehandlung - Aquafacial', duration: '60 Min.', price: '99€' },
      { name: 'Gesichtsbehandlung - HydroPeptide Spa Behandlung', duration: '70 Min.', price: '110€' }
    ]
  },
  {
    category: 'Gesichtsbehandlungen (Nur für Damen)',
    items: [
      { name: 'Gesichtsbehandlung - Junior bis 18 Jahre', duration: '60 Min.', price: '55€' },
      { name: 'Gesichtsbehandlung - Time to Relax', duration: '70 Min.', price: '89€' },
      { name: 'Gesichtsbehandlung - Fresh up Treatment', duration: '70 Min.', price: '89€' },
      { name: 'Gesichtsbehandlung - Classic Reinigung', duration: '60 Min.', price: '65€' }
    ]
  },
  {
    category: 'Microdermabrasion',
    items: [
      { name: 'Gesichtsbehandlung - Microdermabrasion', duration: '60 Min.', price: '75€' }
    ]
  },
  {
    category: 'Spezialbehandlungen',
    items: [
      { name: 'Rückenbehandlung - Classic Rückenreinigung', duration: '45 Min.', price: '70€' }
    ]
  }
];
